import { render, staticRenderFns } from "./ReplyTree.vue?vue&type=template&id=1c46754c&"
import script from "./ReplyTree.vue?vue&type=script&lang=ts&"
export * from "./ReplyTree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports